<template>
  <div class="impressum-layout animated fadeIn" v-html="$t('Webportal.Imprint.Content')">
  </div>
</template>

<script>
export default {
  name: 'Imprint',
  computed: {
    appTarget() {
      return APP_TARGET;
    }
  }
}
</script>
